import { Button } from '@/features/uiKit/Button';
import { Stack } from '@/features/uiKit/Stack';
import { Text } from '@/features/uiKit/Text';
import { landingContentFrame } from './landingSettings';

interface CtaBlockProps {
  title: string;
  actionButtonTitle: string;
  actionButtonLink: string;
  actionButtonId?: string;
}
export const CtaBlock: React.FC<CtaBlockProps> = ({
  title,
  actionButtonLink,
  actionButtonTitle,
  actionButtonId,
}) => {
  return (
    <Stack
      sx={{
        width: '100%',
        padding: '110px 0 140px 0',
        '@media (max-width: 600px)': {
          paddingBottom: '80px',
        },
        alignItems: 'center',
        justifyContent: 'center',
        gap: '100px',
        position: 'relative',
        zIndex: 1,
        overflow: 'hidden',
        backgroundColor: '#fff',
        color: '#111',
        boxSizing: 'border-box',
      }}
    >
      <Stack
        sx={{
          ...landingContentFrame,
          alignItems: 'center',
          gap: '50px',
        }}
      >
        <Stack
          sx={{
            maxWidth: '890px',
            gap: '20px',
            alignItems: 'center',
          }}
        >
          <Text as="h2" variant="title" align="center">
            {title}
          </Text>
        </Stack>
        <Stack sx={{ width: '100%', maxWidth: '1300px' }}>
          <Button
            href={actionButtonLink}
            id={actionButtonId}
            data-analytics={actionButtonId}
            size="xl"
            fullWidth
          >
            {actionButtonTitle}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
